const accordions = document.querySelectorAll('.hall-of-fame_wrapper .js-accordion-toggle');

if (accordions.length > 0) {
  const wrapper = accordions[0].closest('.accordion-wrapper');
  if(wrapper.classList.contains('accordion-open')) {
    wrapper.classList.remove('accordion-open');
  } else {
    wrapper.classList.add('accordion-open');
  }
}

accordions.forEach((item) => {
  item.addEventListener('click' , () => {
    const wrapper = item.closest('.accordion-wrapper');
    if(wrapper.classList.contains('accordion-open')) {
      wrapper.classList.remove('accordion-open');
    } else {
      wrapper.classList.add('accordion-open');
    }
  })
})

//swiper Functionalities
const swiperSlides = document.querySelectorAll('.accordion-content.swiper-wrapper .shopify-block');

if(window.innerWidth <= 767) {
  swiperSlides.forEach(element => {
    element.classList.add('swiper-slide');
  });
}
const swipers = []; // To store Swiper instances

// Function to init/destroy Swiper based on screen width
function handleSwiper() {
  const isMobile = window.innerWidth <= 767;

  document.querySelectorAll('.accordion-swiper').forEach((swiperEl, index) => {
    if (isMobile && !swipers[index]) {
      // Init Swiper if not already initialized
      swipers[index] = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev')
        },
      });
    } else if (!isMobile && swipers[index]) {
      // Destroy Swiper if exists and screen is larger
      swipers[index].destroy();
      swipers[index] = null;
    }
  });
}

// Run on load
handleSwiper();

// Run on resize
window.addEventListener('resize', handleSwiper);

//Play Video

const playButton = document.querySelectorAll(".accordion_video-wrapper deferred-media");

playButton.forEach((button) => {
  button.addEventListener('click',()=> {
    const svgLogo = button.closest('.accordion_video-wrapper').querySelector('.svg_logo');
    svgLogo.classList.add('hidden');
  })
})